import { render, staticRenderFns } from "./OrderActivityCard.vue?vue&type=template&id=4be8903c&"
import script from "./OrderActivityCard.vue?vue&type=script&lang=js&"
export * from "./OrderActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderActivityCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports